<template>
  <div class="card accompagnement-card h-100 shadow-sm">
    <div class="card-img-top-wrapper">
      <img
        src="@/assets/img/photo/aqua/personne-agee-piscine.jpeg"
        class="card-img-top"
        :alt="$t('espaceAquasensorielResume.image.alt')"
      />
    </div>
    <div class="card-body d-flex flex-column">
      <h5 class="fw-bold" style="font-size: 1.3rem">
        {{ $t("espaceAquasensorielResume.title") }}
      </h5>

      <p class="text-muted" style="font-size: 1rem; line-height: 1.4">
        {{ $t("espaceAquasensorielResume.text.p1") }}
        <br />
        {{ $t("espaceAquasensorielResume.text.p2") }}
      </p>

      <router-link
        to="/espace-aquasensoriel"
        class="btn btn-custom mt-2 w-100 mt-auto"
      >
        {{ $t("espaceAquasensorielResume.button.more") }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "EspaceAquasensorielResume",
};
</script>

<style></style>
